import { SET_PRESENTATION_LIST, SET_PRESENTATION_USER_NAME } from './constants';

export default {
  [SET_PRESENTATION_LIST](state, data) {
    state.list = data;
    localStorage.setItem('presentation-products', JSON.stringify(data));
  },
  [SET_PRESENTATION_USER_NAME](state, userName) {
    state.userName = userName;
  }
};
